
import React from "react";
import { IAchievement } from "../../data";
import styles from "../../assets/style.module.css";

const COLORS = ["c-gold", "c-sky", "c-pink"];

export interface AwardsBandProps {
    achievements: IAchievement[];
}

function AwardsBand({ achievements }: AwardsBandProps) {

    if (!achievements.length) return null;

    return (<div className={styles["band"]}>
        <div className={`${styles["band-fade"]} ${styles["band-fade-left"]}`} />
        <div className={`${styles["band-fade"]} ${styles["band-fade-right"]}`} />
        <div className={styles["band-track"]}>
            {[...achievements, ...achievements].map((a, i) => (<div key={i} className={styles["band-item"]}>
                <div className={`${styles["band-num"]} ${styles[COLORS[i % COLORS.length]]}`}><i className={a.icon} /> {a.year}</div>
                <div className={styles["band-lbl"]}>{a.title}</div>
            </div>))}
        </div>
    </div>);
}

export default AwardsBand;
